import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from '../../../components/Link';
import { getAppDetail } from '../reducers/apps/details';
import AppDetailBox from '../../../components/apps/AppDetailBox';
import { routes } from '../../../routesConstants';

class AppDetail extends Component {
  render() {
    const { app, vendor } = this.props;
    return (
      <div>
        <div className="container">
          <Link to={routes.ROUTE_HOME}>&larr; Go to components listing</Link>
          <AppDetailBox module="home" app={app} vendor={vendor} />
        </div>
      </div>
    );
  }
}

AppDetail.propTypes = {
  app: PropTypes.object.isRequired,
  vendor: PropTypes.object.isRequired
};

const mapStateToProps = (state, options) => {
  const { appId } = options.match.params;
  const vendors = state.open.vendors.list;
  const app = getAppDetail(state, appId);
  return {
    app,
    vendor: vendors.find((vendor) => app.vendor.id === vendor.id)
  };
};

export default connect(mapStateToProps)(AppDetail);
